export enum TipoEstoque {
	ESTOQUE_VAZIO = <any>'1',
	ESTOQUE_CHEIO = <any>'2',
	ESTOQUE_UNICO = <any>'3'
}
